module.exports = __webpack_public_path__ + "static/media/728-x-90.330b3fc0.svg";